/**
 * moduleCatalog — Mirror של backend `ModuleCatalog.cs` (מקור-אמת לאכיפה).
 *
 * כאן מוסיפים את ה-`route` לכל פריט פרימיום — נדרש ל-gating בתפריט ול-ModuleRouteGuard.
 * בעת הוספת דוח/נושא חדש — לעדכן גם את `ModuleCatalog.cs` (אחרת drift בין תפריט לאכיפה).
 *
 * חבילת בסיס (isBasic=true): תמיד פעילה — לא נשמרת ב-DB ולא נאכפת.
 * פרימיום (isBasic=false): נשמר ב-CompanyModuleSubscription, ברירת מחדל כבוי, נאכף.
 */

export const MODULE_CATEGORY = {
  GENERAL: 'General',
  REPORTS: 'Reports',
  PROFITABILITY: 'Profitability',
};

// כל פריט: { code, displayName, category, isBasic, route }
// route רלוונטי בעיקר לפריטי פרימיום (לצורך ה-route guard). null = ללא route ייחודי.
export const MODULE_CATALOG = [
  // ── חבילת בסיס (תמיד פעיל) ──
  { code: 'Dashboard',              displayName: 'לוח מחוונים',        category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: '/dashboard' },
  { code: 'EmployeeLoadings',       displayName: 'טעינות עובדים',      category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'EmployeeActivity',       displayName: 'פעילות עובדים',      category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'Locations',              displayName: 'מקומות',             category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'TerminalLoadingsPerDay', displayName: 'טעינות מסופים ליום', category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'SpecialDays',            displayName: 'ימים מיוחדים',       category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'CashExpenses',           displayName: 'הוצאות במזומן',      category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },
  { code: 'Management',             displayName: 'ניהול',              category: MODULE_CATEGORY.GENERAL, isBasic: true,  route: null },

  // ── פרימיום יחיד ──
  { code: 'SendMessages',           displayName: 'שליחת הודעות',       category: MODULE_CATEGORY.GENERAL, isBasic: false, route: '/admin/send-message' },

  // ── דוחות (פר-דוח) ──
  { code: 'Report.AgentCashExpense',              displayName: 'דוח הוצאת כסף סוכן',   category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/agent-cash-expense' },
  { code: 'Report.Reference',                     displayName: 'דוח התייחסות',         category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/reference' },
  { code: 'Report.Terminal',                      displayName: 'דוח מסופים',           category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/terminal' },
  { code: 'Report.WithdrawalCount',               displayName: 'דוח משיכות',           category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/withdrawal-count' },
  { code: 'Report.CheckFlow',                     displayName: 'זרימת כסף',            category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/check-flow' },
  { code: 'Report.MoneyTrail',                    displayName: 'מסלול כסף',            category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/money-trail' },
  { code: 'Report.EmployeeBalance',               displayName: 'יתרת עובדים',          category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/employee-balance' },
  { code: 'Report.BatchLinesReconciliation',      displayName: 'הצלבת אצוות חשבוניות', category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/batch-lines-reconciliation' },
  { code: 'Report.CasponetInvoiceVerification',   displayName: 'אימות חשבונית כספונט', category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/casponet-invoice-verification' },
  { code: 'Report.MissingInvoiceBatches',         displayName: 'אצוות חסרות מ-Casponet',category: MODULE_CATEGORY.REPORTS, isBasic: false, route: '/report/missing-invoice-batches' },

  // ── רווחיות (פר-נושא) ──
  { code: 'Profitability.InvoiceScan',     displayName: 'שיוך חשבוניות סרוקות', category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/invoice-scan' },
  { code: 'Profitability.MonthlyReport',   displayName: 'רווחיות לחודש',        category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/monthly-report' },
  { code: 'Profitability.PaymentSchedule', displayName: 'תשלום למקומות',        category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/payment-schedule' },
  { code: 'Profitability.Invoices',        displayName: 'חשבוניות מקומות',      category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/invoices' },
  { code: 'Profitability.Expenses',        displayName: 'חשבוניות ספקים',       category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/expenses' },
  { code: 'Profitability.RevenueInvoices', displayName: 'חשבוניות הכנסה',       category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/revenue-invoices' },
  { code: 'Profitability.Salary',          displayName: 'שכר עובדים',           category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/salary' },
  { code: 'Profitability.LocationGroups',  displayName: 'ניהול ריכוז ספקים',    category: MODULE_CATEGORY.PROFITABILITY, isBasic: false, route: '/profitability/location-groups' },
];

export const BASIC_CODES = new Set(MODULE_CATALOG.filter((m) => m.isBasic).map((m) => m.code));
export const PREMIUM_CODES = new Set(MODULE_CATALOG.filter((m) => !m.isBasic).map((m) => m.code));

/** כל פריטי הפרימיום של קטגוריה (לבדיקת "יש child פעיל" בכותרת קטגוריה). */
export const getCategoryChildren = (category) =>
  MODULE_CATALOG.filter((m) => m.category === category && !m.isBasic);

/**
 * מיפוי pathname → פריט קטלוג, לפי התאמת prefix הארוכה ביותר.
 * משמש את ModuleRouteGuard כדי לזהות לאיזה מודול שייך ה-route הנוכחי.
 */
export const getModuleByRoute = (pathname) => {
  if (!pathname) return null;
  let best = null;
  for (const m of MODULE_CATALOG) {
    if (!m.route) continue;
    if (pathname === m.route || pathname.startsWith(m.route + '/')) {
      if (!best || m.route.length > best.route.length) best = m;
    }
  }
  return best;
};
